// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"d9b82997","51":"267e4b06","89":"46513992","117":"ad402f03","134":"ed83623a","264":"cdebffb6","453":"0a63b899","638":"60210a7a","881":"09282f08"}[chunkId] + ".chunk.js";
};